/*!
 */

;(function ( $, window, document, undefined ) {

    var pluginName = 'beGroupOffers',
        defaults = {
            propertyName: "value"
        };

    // The actual plugin constructor
    function Plugin( element, options ) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend( {}, defaults, options) ;

        this._defaults = defaults;
        this._name = pluginName;
        this.addButton = $('.js-add-row');
        this.selection = $('#js-selection-data');
        this.submitButton = $('#submit-button');
        this.urlTemplate = $(element).attr('data-url-template');
        this.urlData = $(element).attr('data-url-data');
        this.urlGet = $(element).attr('data-url');
        this.init();
    }

    Plugin.prototype.init = function () {
        var Plugin = this;
            Plugin.setEvents();
    };

    Plugin.prototype.setEvents = function () {
        var Plugin = this;
        Plugin.addButton.on('click', function () {
            Plugin.addRow();
        })

        $('.js-table-add').on('click',".js-delete-row", function () {
            Plugin.deleteRow($(this));
        })
        Plugin.submitButton.on('click', function () {
            Plugin.sendForm();
        });

    };

    Plugin.prototype.deleteRow = function (element) {
        element.closest('tr').remove();
        if($("tr").length<6){
            $('#submit-button').addClass('hide');
        }
    };

    Plugin.prototype.addRow = function () {
        var Plugin = this;
        if(Plugin.selection.val()!='' && Plugin.selection.val()!=null && $("tr").length < 6 && Plugin.validateRow(Plugin.selection.val())) {

           Plugin.getData();

        }
    };

    Plugin.prototype.getData = function () {
        var Plugin = this;
        $.ajax({
            url: window.location.origin + Plugin.urlData + Plugin.selection.val(),
            type: 'GET',
            success: function (data) {
                Plugin.loadTemplate(data);
            },
            error: function (data) {
                console.error('Error')
            }
        });
    }

    Plugin.prototype.loadTemplate = function (dataOffer) {
        var Plugin = this;
        $.get(window.location.origin + Plugin.urlTemplate).success(function(data) {
            var template = $.templates(data);
            var tmpHtml = template.render(dataOffer);
            var row = $(tmpHtml);
            $('.js-table-add').append(row);
            Plugin.selection.text('');
            // Plugin.selection.val('');
            Plugin.selection.html('');
            Plugin.selection.val(null).trigger('change.select2');
            if($("tr").length>=6){
                $('#submit-button').removeClass('hide');
            }
        });
    };

    Plugin.prototype.validateRow = function (val) {
        var NoRepeat = true;
        $( ".js-offer" ).each(function( index ) {
            if(val == $( this ).attr("data-value")){
                NoRepeat = false;
            }
        });
        return NoRepeat;
    };


    Plugin.prototype.sendForm = function (data) {
        var Plugin = this;
        var data = [];
        var name = $("#name").val();
        var description = $("#description").val();
        $( ".js-offer" ).each(function( index ) {
            data.push($( this ).attr("data-value"));
        });
        $.ajax({
            url: window.location.origin + Plugin.urlGet,
            type: 'POST',
            data: {'data':data, 'name':name, 'description':description},
            success: function (data) {

                Plugin.removeAlerts(data);
                Plugin.throwAlerts(data);

            },
            error: function (data) {
                Plugin.removeAlerts(data);
                Plugin.throwAlerts(data);
                console.error('Error al cargar la imagen')
            }
        });
        return false;

    };

    Plugin.prototype.removeAlerts = function(){
        $(document).find('.has-error').toggleClass('has-error');
    };

    Plugin.prototype.throwAlerts = function(data){
        var Plugin = this;

        var response = '';

        if(data.responseText){
            response = jQuery.parseJSON(data.responseText);
            if(response.msg && response.msg.ValidationErrors) {
                $.each(response.msg.ValidationErrors, function (index, value) {
                    $('[name=' + index + '], [data-name=' + index + ']').parent().addClass('has-error');
                    $('[name=' + index + '], [data-name=' + index + ']').find('.select2-selection').toggleClass('has-error');
                });
            }
        }
        else{
            response = data;
        }

        $.ajax({
            url: window.location.origin + '/alert-template',
            type: 'POST',
            data: {
                msg : response.msg,
                status : response.status
            },
            success: function(data){
                var msg = $('.o-form__msg').html(data);
            },
            error: function(data){
                var msg = $('.o-form__msg').html(data);
            }
        });
    };



    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin( this, options ));
            }
        });
    }

})( jQuery, window, document );/**
 * Created by miguelgonzalez on 8/11/17.
 */
